import styled from 'styled-components';

export const Wrap = styled.div``;

export const HeaderWrap = styled.div`
  position: relative;
  display: flex;
  height: 28px;
`;

export const Arrows = styled.div`
  color: #8e8e8e;
  svg:first-child {
    position: absolute;
    top: 3px;
  }

  svg:last-child {
    position: absolute;
    right: 0px;
    top: 3px;
  }
`;

export const HDate = styled.div`
  background-color: ${props => (props.isSelectedDate ? '#468CF0' : '#f5f5f5')};
  font-weight: 700;
  color: ${props => (props.isSelectedDate ? '#fff' : '#8e8e8e')};
  width: ${props => `${100 / props.divideBy}%`};
  text-align: center;
  padding-top: 2px;
  height: 27px;
  font-size: 12px;
  line-height: 24px;
`;
